module.exports = __webpack_public_path__ + "static/media/php.94242182.png";